import * as z from 'zod';
export const SyntheticDemographicsSchema = z.object({
    id: z.string().optional(),
    seed: z.string().optional(),
    age: z.number().optional(),
    gender: z.enum(['male', 'female', 'non-binary', 'unknown']).optional(),
    skinTone: z.enum(['light', 'medium', 'dark']).optional(),
    // We can add more specific fields if needed
});
//# sourceMappingURL=types.js.map